import { defineStore } from 'pinia'

export const useSharedListStore = defineStore('sharedList', {
  state: () => {
    return {
      lists: [],
    }
  },
  actions: {
    registerList(name, items) {
      const listRecord = {'name': name, 'items': items};

      const existingListIndex = this.lists.findIndex(l => l.name === name);
      if (existingListIndex >= 0) {
        this.lists[existingListIndex] = listRecord;
        return;
      }

      this.lists.push(listRecord);
    },

    getItems(name) {
      const list = this.lists.find(l => l.name === name);
      if (!list) return null;

      return list.items;
    }
  }
})
